<template v-if="false">
  <div>
    <div class="item-logo-container" @mouseover="isShown = true" @mouseleave="isShown = false">
      <Transition>
        <div class="remove-logo d-flex justify-content-center align-items-center" v-if="!isDefault && isShown && (logoPreview || imagePath)" @click="removeLogo">
          <i class="bx bx-trash-alt"></i>
        </div>
      </Transition>
      <img
        :src="imgPath"
        @error="onError"
        class="img-fluid mx-auto d-block m-2 border border border-info item-logo"
        />
    </div>
    <label
      for="formFile"
      class="form-label small fw-bold"
      >Upload {{label}}<span style="color: red">{{isRequired? '*':''}}</span></label
    >
    <template v-if="shouldValidate">
      <validation-provider :name="label" :rules="rule" v-slot="validationContext">
        <b-form-file
          class="form-control"
          type="file"
          v-model="file"
          :state="getValidationState(validationContext)"
          @change="onFileChange"
          plain
        />
        <b-form-invalid-feedback>
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </validation-provider>
    </template>

    <template v-if="!shouldValidate">
      <b-form-file
        class="form-control"
        type="file"
        v-model="file"
        @change="onFileChange"
        plain
      />
    </template>
  </div>
</template>
<!--
  Modified by:  john mark arquitola
  Date:         Nov 21, 2022
  Description:  add red border at image when it is required
-->
<template>
  <validation-provider :name="label" :rules="rule" v-slot="validationContext">
    <div @mouseover="isShown = true" @mouseleave="isShown = false">
      <div class="item-logo-container" >
        <Transition>
          <div class="remove-logo d-flex justify-content-center align-items-center" v-if="!isDefault && isShown && (logoPreview || imagePath)" @click="removeLogo">
            <i class="bx bx-trash-alt"></i>
          </div>
        </Transition>
        <img
          :src="imgPath"
          @error="onError"
          class="img-fluid mx-auto d-block m-2 item-logo"
          :class="{ 'border border-info': getValidationState(validationContext), 'img-invalid': getValidationState(validationContext)===false}"
          />
      </div>
      <label
        for="formFile"
        class="form-label small fw-bold"
        >Upload {{label}}<span style="color: red">{{isRequired? '*':''}}</span></label
      >
      <template v-if="shouldValidate">
        <b-form-file
          class="form-control"
          type="file"
          v-model="file"
          :state="getValidationState(validationContext)"
          @change="onFileChange"
          plain
      />
      <b-form-invalid-feedback>
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
      </template>
  
      <template v-if="!shouldValidate">
        <b-form-file
          class="form-control"
          type="file"
          v-model="file"
          @change="onFileChange"
          plain
        />
      </template>
    </div>
  </validation-provider>
  </template>
<script>
import shortid from "shortid";
import _ from "lodash";

export default {
  name: 'image-upload',
  data(){
    return {
      isDefault: false,
      isShown: false,
      file: null,
      logoPreview: null,
      imagePath: null,
      logo: {
        filename: null,
        type: null,
        base64: null
      }
    }
  },
  computed: {
    rule: {
      get(){
        if(this.shouldValidate){
          return this.isRequired ? 'required':'';
        } else {
          return '';
        }
      }
    },
    shouldValidate: {
      get(){
        return this.isRequired && this.imagePath == null;
      }
    },
    imgPath: {
      get(){
        var imgPath = '';
        if(this.imagePath){
          imgPath = this.imagePath;
        }
        
        if(this.logoPreview){
          imgPath = this.logoPreview
        } 

        return imgPath;
      }
    },
  },
  props: ['label','isRequired','imageSrc','value'],
  methods: { 
    onError(e){
      console.log('Load default logo');
      this.isDefault = true;
      this.imagePath = null;
      e.target.src = require('@/assets/images/img-placeholder.png')
    },
    onFileChange(e){
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length){
        this.logoPreview = null;
        this.$emit("input", {
          filename: null,
          type: null,
          base64: null
        });
        return;
      }

      this.isDefault = false;
      this.logoPreview = URL.createObjectURL(files[0]);

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.logo.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''), 'base64');
        this.logo.type = base64Data.split(';')[0].split('/')[1];
        if(this.logo.type == 'svg+xml'){
          this.logo.type = 'svg';
        }
        this.logo.filename = `${shortid.generate()}.${this.logo.type}`;
        this.$emit("input", _.cloneDeep(this.logo));
      }
      reader.readAsDataURL(files[0]);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    removeLogo(){
      this.$emit("input", {
        filename: null,
        type: null,
        base64: null
      });
      this.file = null;
      this.imagePath = null;
      this.logoPreview = null;
    }
  },
  mounted(){
    this.imagePath = this.imageSrc;
  }
}
</script>

<style>
.item-logo {
  max-width: 200px;
  max-height: 200px;
}

.item-logo-container {
  max-width: 200px;
  position: relative;
  margin: 0 auto;
}

.remove-logo {
  cursor: pointer;
  border-radius: 50%;
  background: #E9EAEC;
  width: 30px;
  height: 30px;
  position: absolute;
  right: -10px;
  top: -10px;
  color: #E73092;
  transition: opacity 3s;
}

.remove-logo.shown {
  opacity: 1;
}

.remove-logo:hover {
  background: #E73092;
  color: #FFF;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.img-invalid {
  border: solid 1px #FF0000;
}
</style>